import React from 'react'
import mb from './photolic/bimabhart.jpg'
import './image.css'
const Bachat = () => {
  return (
    <div>
      <img src={mb} alt="" className='eimg'/>
    </div>
  )
}

export default Bachat
